import type { ReactNode } from 'react';

import type { SDSFlexboxAlignItems, SDSFlexboxJustifyContent } from '@repo/sds/components/SDSFlexbox';
import { SDSFlexbox } from '@repo/sds/components/SDSFlexbox';

export interface SDSButtonGroupProps {
  className?: string;
  children: ReactNode;
  size?: 'small' | 'medium' | 'large';
  mode?: 'horizontal' | 'vertical';
  justifyContent?: SDSFlexboxJustifyContent;
  alignItems?: SDSFlexboxAlignItems;
  isFullWidth?: boolean;
}

export function SDSButtonGroup({
  className,
  children,
  size = 'medium',
  mode = 'horizontal',
  justifyContent = 'center',
  alignItems = 'center',
  isFullWidth = false,
}: SDSButtonGroupProps) {
  const gapMap = {
    small: 'button-regular',
    medium: 'button-medium',
    large: 'button-large',
  } as const;

  return (
    <SDSFlexbox
      className={className}
      direction={mode === 'horizontal' ? 'row' : 'column'}
      justifyContent={justifyContent}
      fullWidth={isFullWidth}
      alignItems={alignItems}
      gap={gapMap[size]}
    >
      {children}
    </SDSFlexbox>
  );
}
